import React from 'react';
import { usePopupContext } from '../contexts/PopupContext';
import GatedMeasureNoticePopup from './GatedMeasureNoticePopup';
import GradeNotAvailablePopup from './GradeNotAvailablePopup';
import D8AlternateFormSelectionPopup from './D8AlternateFormSelectionPopup';
import LecturaAltFormSelectionPopup from './LecturaAltFormSelectionPopup';
import VocAssessNoticePopup from './VocAssessNoticePopup';
import CSFormSelectionPopup from './CSFormSelectionPopup';
import BurstAltFormSelectionPopup from './BurstAltFormSelectionPopup';
import PMFormSelectionPopup from '../../components/students-list/pm-summary/PMFormSelectionPopup';
import MazeScorePopup from './MazeScorePopup';
import CPScorePopup from './CPScorePopup';
import AINoDetailsAvailablePopup from './AINoDetailsAvailablePopup';
import LecturaNoDetailsAvailablePopup from './LecturaNoDetailsAvailablePopup';
import NoResultDetailsPopup from './NoResultDetailsPopup';
import UnofficialResultPopup from './UnofficialResultPopup';
import CreatePresumedResultPopup from './CreatePresumedResultPopup';
import DeletePresumedResultPopup from './DeletePresumedResultPopup';
import NoDetailsAvailablePopup from './NoDetailsAvailablePopup';
import OrfG5BoyFormPopup from './OrfG5BoyFormPopup';
import OrfG5PMForm1AltTextPopup from './OrfG5PMForm1AltTextPopup';
import DigitalFormsPopup from './DigitalFormsPopup';
import TRCOutsideBMPopup from './TRCOutsideBMPopup';
import NoIDELSupportPopup from './NoIDELSupportPopup';

const PopupsContainer = () => {
    const {
        isGatedMeasureNoticePopupOpen,
        isGradeNotAvailablePopupOpen,
        isD8AlternateFormSelectionPopupOpen,
        isLecturaAltFormSelectionPopupOpen,
        isVocAssessNoticePopupOpen,
        isCSFormSelectionPopupOpen,
        isBurstAltFormSelectionPopupOpen,
        isPMFormSelectionPopupOpen,
        isMazeScorePopupOpen,
        isCPScorePopupOpen,
        isAINoDetailsAvailablePopupOpen,
        isLecturaNoDetailsAvailablePopupOpen,
        isNoResultDetailsPopupOpen,
        isUnofficialResultPopupOpen,
        isCreatePresumedResultPopupOpen,
        isDeletePresumedResultPopupOpen,
        isNoDetailsAvailablePopupVisible,
        isOrfG5BoyFormPopupOpen,
        isOrfG5PMForm1AltTextPopupOpen,
        isDigitalFormsPopupOpen,
        isTRCOutsideBMPopupOpen,
        isNoIDELSupportPopupOpen,
    } = usePopupContext();
    return (
        <>
            {isGatedMeasureNoticePopupOpen && <GatedMeasureNoticePopup />}
            {isGradeNotAvailablePopupOpen && <GradeNotAvailablePopup />}
            {isD8AlternateFormSelectionPopupOpen && <D8AlternateFormSelectionPopup />}
            {isLecturaAltFormSelectionPopupOpen && <LecturaAltFormSelectionPopup />}
            {isVocAssessNoticePopupOpen && <VocAssessNoticePopup />}
            {isCSFormSelectionPopupOpen && <CSFormSelectionPopup />}
            {isBurstAltFormSelectionPopupOpen && <BurstAltFormSelectionPopup />}
            {isPMFormSelectionPopupOpen && <PMFormSelectionPopup />}
            {isMazeScorePopupOpen && <MazeScorePopup />}
            {isCPScorePopupOpen && <CPScorePopup />}
            {isAINoDetailsAvailablePopupOpen && <AINoDetailsAvailablePopup />}
            {isLecturaNoDetailsAvailablePopupOpen && <LecturaNoDetailsAvailablePopup />}
            {isNoResultDetailsPopupOpen && <NoResultDetailsPopup />}
            {isUnofficialResultPopupOpen && <UnofficialResultPopup />}
            {isCreatePresumedResultPopupOpen && <CreatePresumedResultPopup />}
            {isDeletePresumedResultPopupOpen && <DeletePresumedResultPopup />}
            {isNoDetailsAvailablePopupVisible && <NoDetailsAvailablePopup />}
            {isOrfG5BoyFormPopupOpen && <OrfG5BoyFormPopup />}
            {isOrfG5PMForm1AltTextPopupOpen && <OrfG5PMForm1AltTextPopup />}
            {isDigitalFormsPopupOpen && <DigitalFormsPopup />}
            {isTRCOutsideBMPopupOpen && <TRCOutsideBMPopup />}
            {isNoIDELSupportPopupOpen && <NoIDELSupportPopup />}
        </>
    );
};

export default PopupsContainer;
